import React, { useEffect, useState } from 'react';
import { ArrowUpRight, ArrowDownRight, Pause, Play } from 'lucide-react';
import { API } from './siteConfig';

const REFRESH_MS = 60000;

const Quote = ({ q }) => {
  const up = q.change_pct >= 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <li className="mk-tape-item">
      <span className="mk-tape-sym">{q.symbol}</span>
      <span className="mk-num">${q.price.toFixed(2)}</span>
      <span className={`mk-num mk-dir ${up ? 'up' : 'down'}`}>
        <Icon size={13} aria-hidden="true" />
        <span className="sr-only">{up ? 'up' : 'down'}</span>
        {up ? '+' : ''}{q.change_pct.toFixed(2)}%
      </span>
    </li>
  );
};

export const TickerTape = () => {
  const [data, setData] = useState(null);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () => fetch(`${API}/api/public/tape`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => alive && setData(j && j.available && j.quotes?.length ? j : false))
      .catch(() => alive && setData(false));
    load();
    const id = setInterval(load, REFRESH_MS);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (data === false) return null;
  const items = data ? data.quotes.map((q) => <Quote key={q.symbol} q={q} />) : null;

  return (
    <section className={`mk-tape ${paused ? 'paused' : ''}`} aria-label="Delayed market quotes" data-testid="ticker-tape">
      <p className="mk-tape-label" data-testid="ticker-tape-label">
        {data ? `Delayed ${data.delay_minutes} min · as of ${data.as_of_et}` : 'Loading delayed quotes'}
      </p>
      <div className="mk-tape-viewport">
        {data && (
          <div className="mk-tape-track">
            <ul className="mk-tape-list">{items}</ul>
            <ul className="mk-tape-list mk-tape-dup" aria-hidden="true">{items}</ul>
          </div>
        )}
      </div>
      {data && (
        <button type="button" className="mk-tape-toggle" onClick={() => setPaused((p) => !p)}
          aria-label={paused ? 'Resume ticker scrolling' : 'Pause ticker scrolling'} aria-pressed={paused} data-testid="ticker-tape-toggle">
          {paused ? <Play size={14} /> : <Pause size={14} />}
        </button>
      )}
    </section>
  );
};
